import type { FC } from 'react';
import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';

import { Button, MenuIcon } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import { triggerAccountSlidingSidebarEvent } from 'Services/analytics/events';
import Drawer from 'Storybook/core/Drawer/Drawer';
import AccountSidebar from 'Storybook/local/AccountSidebar/AccountSidebar';
import { Variant } from 'Types/variant';
import { applyCypressData } from 'Utilities/helpers';

import styles from './AccountSidebarDrawer.module.scss';

export const Menu: FC = () => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const triggerRef = useRef<HTMLButtonElement>(null);

	const router = useRouter();

	const handleOpen = () => {
		setIsOpen(true);
		triggerAccountSlidingSidebarEvent(true);
	};

	const handleClose = () => {
		setIsOpen(false);
		triggerAccountSlidingSidebarEvent(false);
	};

	useEffect(() => {
		const handleRouteChange = () => {
			if (isOpen) setIsOpen(false);
		};

		router.events.on('routeChangeStart', handleRouteChange);
		router.events.on('hashChangeStart', handleRouteChange);

		return () => {
			router.events.off('routeChangeStart', handleRouteChange);
			router.events.off('hashChangeStart', handleRouteChange);
		};
	}, [router, setIsOpen, isOpen]);

	return (
		<>
			<div className={styles.wrap}>
				<Button
					{...applyCypressData(cypressIds.buttons.accountPageMenu)}
					ref={triggerRef}
					icon={MenuIcon}
					label={'Menu'}
					onClick={handleOpen}
					showLabel={false}
					size="medium"
					type="button"
					variant="tertiary"
				/>
			</div>
			<Drawer
				data-testid="account-sidebar-drawer"
				isOpen={isOpen}
				onClose={handleClose}
				size="fit-content"
				triggerRef={triggerRef}
				variant={Variant.SECONDARY}
			>
				<div className={styles.sidebarContainer}>
					<AccountSidebar />
				</div>
			</Drawer>
		</>
	);
};
